// https://3.basecamp.com/3633946/buckets/6317965/todos/1600449724
export function recalculateCoord(coordinate, order, length, radius = 10) {
  const round = function(number) {
    return parseFloat(number.toFixed(5));
  };
  const lng = function(coordinate, radian, radius) {
    const distance = round(Math.cos(radian) * radius);
    return parseFloat(coordinate[0]) + (360 * distance / 40075000);
  };
  const lat = function(coordinate, radian, radius) {
    const distance = round(Math.sin(radian) * radius);
    return parseFloat(coordinate[1]) + (360 * distance / 40075000);
  };
  const angle = order * 360 / length;
  const radian = angle * Math.PI / 180;
  return [lng(coordinate, radian, radius), lat(coordinate, radian, radius)];
}

export function sameCoordGrouper(pois) {
  const set = {};
  pois.forEach((result, idx) => {
    if (result.coordinate && result.coordinate[0]) {
      if (Array.isArray(result.coordinate[0])) {
        result.coordinate.forEach(coordinate => {
          const hash = `${coordinate[0]},${coordinate[1]}`;
          set[hash] = set[hash] ? [...set[hash], idx] : [idx];
        });
      } else {
        const coordinate = result.coordinate;
        const hash = `${coordinate[0]},${coordinate[1]}`;
        set[hash] = set[hash] ? [...set[hash], idx] : [idx];
      }
    }
  });
  // console.log('[sameCoordGrouper]:', set);
  return Object.values(set) // no need `.filter(group => group.length > 1)`
}
